import { NumericFormat } from "react-number-format"

import { sanitizeAndDecodeHtml } from "@/utils/helper"
import ToolTip from "@/components/core/ToolTip/ToolTip"

const ListPrice = props => {
  const {
    listPrice = 0,
    staticTexts: {
      listPriceInfo = "",
      refPrice = "",
      listPrice: listPriceText = "",
    } = {},
    currencySign = "",
    priceTooltip = false,
    setPriceTooltip = () => {},
    handleSetPriceTooltip = () => {},
  } = props

  const handleKeyDown = e => {
    if (e.keyCode === 27) {
      setPriceTooltip(false)
      e.preventDefault()
    }
  }

  return (
    <div className="product-detail-page__list-view">
      <div className="product-detail-page__list-value">
        <NumericFormat
          value={listPrice}
          displayType={"text"}
          thousandSeparator={true}
          prefix={currencySign}
          decimalScale={2}
          fixedDecimalScale={true}
          tabIndex="0"
          aria-label={`${listPriceText} ${currencySign}${listPrice}`}
        />
      </div>
      <div
        className="product-detail-page__list-text"
        onMouseOver={() => handleSetPriceTooltip("list info mouseover", true)}
        onMouseLeave={() => setPriceTooltip(false)}
        tabIndex="0"
        aria-describedby="price-list-info-tooltip"
        onFocus={() => handleSetPriceTooltip("list info focus", true)}
        onBlur={() => setPriceTooltip(false)}
        onKeyDown={handleKeyDown}
      >
        {" "}
        {refPrice}
        <div
          className={`product-detail-page__list-tooltip${
            priceTooltip ? "--show" : "--hide"
          }`}
        >
          <div className="product-detail-page__list-tooltip-wrapper">
            <ToolTip
              id="price-list-info-tooltip"
              message={sanitizeAndDecodeHtml(listPriceInfo)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListPrice
